import { leaveManagementServiceApi } from "../../app/leaveManagementServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetApprovalSettingParams,
  GetApprovalSettingResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";

export const leaveProrateApi = leaveManagementServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalSetting: builder.query<
      GetApprovalSettingResponseType,
      GetQueryArgsType<GetApprovalSettingParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getApprovalSetting,
        ...queryArgs,
      }),
      providesTags: ["GetApprovalSettingList"],
    }),
    addApprovalSetting: builder.mutation({
      query: (data) => ({
        url: API_URL.addApprovalSetting,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetApprovalSettingList"],
    }),
    updateApprovalSetting: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ id, body }) => ({
        url: `${API_URL.updateApprovalSetting}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result) return ["GetApprovalSettingList"];

        return [];
      },
    }),
    deleteApprovalSetting: builder.mutation({
      query: (data) => ({
        url: API_URL.deleteApprovalSetting,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetEmployeeProrateList"],
    }),
  }),
});

export const {
  useGetApprovalSettingQuery,
  useAddApprovalSettingMutation,
  useUpdateApprovalSettingMutation,
  useDeleteApprovalSettingMutation,
} = leaveProrateApi;
